<template>
  <div class="fan fan-component f-plugin-product">
    <f-layout ref="flayout"
              :superPage="page"
              :superApi="superApi"
              @reloadData="reloadData">
      <template #subHeadLeft>
        <f-search :superFilter="filter" :superColumns="superColumns"
                  @change="handleSearch" @reloadData="reloadData" />
      </template>
      <template #subHeadRight>
        <a-button-group>
          <a-button @click="reloadData"><template #icon><icon-refresh /></template>刷新</a-button>
          <a-button type="primary" @click="$refs.flayout.bindOpenCurd('新增')">
            <template #icon><icon-plus /></template>新增
          </a-button>
        </a-button-group>
      </template>
      <template #body>
        <a-spin :loading="loading" tip="加载中...">
          <div class="prod-grid">
            <div v-for="item in dataList" :key="item.id" class="prod-card" @click="handleView(item)">
              <div class="prod-img-wrap">
                <img v-if="getFieldValue(item, imageField)" :src="getFieldValue(item, imageField)" class="prod-img" />
                <div v-else class="prod-img-placeholder"><icon-image style="font-size:48px;color:#c9cdd4;" /></div>
              </div>
              <div class="prod-info">
                <div class="prod-name">{{ getFieldValue(item, titleField) || item.name || '-' }}</div>
                <div class="prod-price">¥{{ formatPrice(getFieldValue(item, priceField)) }}</div>
                <div v-for="col in infoColumns" :key="col.dataIndex" class="prod-meta">
                  <span class="meta-label">{{ col.title }}：</span>
                  <span class="meta-value">{{ getDisplayValue(item, col) }}</span>
                </div>
              </div>
              <div class="prod-actions" v-if="$slots.customAction" @click.stop>
                <slot name="customAction" :record="item"></slot>
              </div>
            </div>
          </div>
        </a-spin>
        <div class="pagination-wrap">
          <a-pagination :total="total" :page-size="filter.limit" :current="filter.page"
                        :page-size-options="[8, 12, 16, 24]" show-total show-page-size
                        @change="handlePageChange" @page-size-change="handleSizeChange" />
        </div>
      </template>
    </f-layout>
  </div>
</template>

<script>
export default {
  name: 'FPluginProduct',
  props: {
    superTitle: { type: String, default: '' },
    superApi: { type: String, default: '' },
    superColumns: { type: Array, default: () => [] }
  },
  data() { return { page: {}, loading: false, dataList: [], total: 0, filter: {} } },
  computed: {
    titleField() {
      const col = this.superColumns.find(c => c.dataIndex && c.dataIndex !== 'id' && c.key !== 'action' && (!c.hidden || !c.hidden.includes('list')))
      return col ? col.dataIndex : 'name'
    },
    imageField() {
      const col = this.superColumns.find(c => c.form === 'image' || c.form === 'upload' || c.form === 'images')
      return col ? col.dataIndex : ''
    },
    priceField() {
      const col = this.superColumns.find(c => c.dataIndex === 'price' || c.form === 'decimal' || c.form === 'price')
      return col ? col.dataIndex : 'price'
    },
    infoColumns() {
      return this.superColumns.filter(c => {
        if (!c.dataIndex) return false
        if (c.form === 'hidden' || c.key === 'action') return false
        if (c.dataIndex === this.titleField || c.dataIndex === this.imageField || c.dataIndex === this.priceField) return false
        return true
      })
    }
  },
  mounted() { this.initPage() },
  activated() { this.initPage() },
  methods: {
    async initPage() {
      this.filter = { page: 1, limit: 8 }
      this.page = this.$fan.utils.parse({ loading: false, initing: false })
      this.$store.state.page.columns = {}
      this.$store.state.page.tableColumns = []
      this.$store.state.page.keyinfo = {}
      if (this.superColumns.length > 0) await this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
      if (this.superApi) this.loadData()
    },
    handleSearch(changes = {}) { this.filter = { ...this.filter, ...changes, page: 1 }; this.loadData() },
    handlePageChange(page) { this.filter.page = page; this.loadData() },
    handleSizeChange(size) { this.filter.limit = size; this.filter.page = 1; this.loadData() },
    async loadData() {
      if (!this.superApi) return; this.loading = true
      try {
        const params = { ...this.filter }; const res = await this.$fan.api.get(this.superApi, params)
        if (res?.status === 0) { this.dataList = (res.data?.data) || []; this.total = Number(res.data?.count) || 0 }
      } catch {} finally { this.loading = false }
    },
    reloadData() { this.filter = { page: 1, limit: 8 }; this.loadData() },
    formatPrice(v) { const n = Number(v); return isNaN(n) ? '0.00' : n.toFixed(2) },
    getFieldValue(obj, path) {
      if (!obj || !path) return undefined
      return path.split(/[.[\]]/).filter(Boolean).reduce((o, k) => (o && o[k] !== undefined) ? o[k] : undefined, obj)
    },
    getDisplayValue(item, col) {
      const raw = this.getFieldValue(item, col.dataIndex)
      if (raw == null || raw === '') return '-'
      if (['select', 'radio', 'cascader', 'selectMultiple','selectTree'].includes(col.form)) {
        const keyinfo = this.$store.state.page?.keyinfo || {}
        const optMap = keyinfo[col.dataIndex]
        if (optMap && (optMap[raw] || optMap[String(raw)])) return (optMap[raw] || optMap[String(raw)]).name
        if (typeof raw === 'string' && raw.includes(',')) return raw.split(',').map(v => { const k = v.trim(); if (optMap && (optMap[k] || optMap[String(k)])) return (optMap[k] || optMap[String(k)]).name; return k }).join(', ')
      }
      return raw
    },
    async handleView(record) {
      await this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
      const cols = this.$store.state.page.columns || {}
      const flat = { ...record }
      this.superColumns.forEach(col => {
        if (!col.dataIndex || !col.dataIndex.includes('[') && !col.dataIndex.includes('.')) return
        let val = this.getFieldValue(record, col.dataIndex)
        if (['select', 'radio', 'cascader','selectTree'].includes(col.form)) {
          val = this.getDisplayValue(record, col)
          if (cols?.[col.dataIndex]) cols[col.dataIndex].form = 'input'
        }
        if (col.unit && val != null && val !== '-') val += ' ' + col.unit
        flat[col.dataIndex] = val
      })
      this.$refs.flayout.bindOpenCurd('详情', { record: flat })
    }
  }
}
</script>

<style scoped lang="less">
.f-plugin-product {
  height: 100%; display: flex; flex-direction: column;
  :deep(.f-layout-content), :deep(.f-layout-level2), :deep(.main), :deep(.mainBody),
  :deep(.mainContent), :deep(.content), :deep(.contentBody) {
    height: 100%; display: flex; flex-direction: column;
  }
  :deep(.contentBody) > div { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
}
.prod-grid {
    padding-top:3px;
  flex: 1; display: grid; grid-template-columns: repeat(4, 1fr);
  gap: 16px; overflow-y: auto; padding-right: 8px; align-content: start;
}
.prod-card {
  background: #fff; border: 1px solid #e5e6eb; border-radius: 8px;
  overflow: hidden; cursor: pointer; transition: all 0.25s;
  &:hover { box-shadow: 0 6px 20px rgba(0,0,0,0.1); transform: translateY(-3px); border-color: #165dff; }
}
.prod-img-wrap {
  width: 100%; height: 160px; background: #f7f8fa; overflow: hidden;
  display: flex; align-items: center; justify-content: center;
}
.prod-img { width: 100%; height: 100%; object-fit: cover; }
.prod-img-placeholder { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; }
.prod-info { padding: 12px 14px 14px; }
.prod-name { font-size: 15px; font-weight: 600; color: #1d2129; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.prod-price { font-size: 18px; font-weight: 700; color: #f53f3f; margin-top: 6px; }
.prod-meta { font-size: 12px; color: #86909c; margin-top: 4px; display: flex; }
.meta-label { flex-shrink: 0; min-width: 60px; }
.meta-value { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.prod-actions { padding: 8px 14px 12px; border-top: 1px solid #f0f1f3; display: flex; gap: 8px; flex-wrap: wrap; }
.pagination-wrap { margin-top: 16px; text-align: right; flex-shrink: 0; }
@media (max-width: 1400px) { .prod-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 992px) { .prod-grid { grid-template-columns: repeat(2, 1fr); } }
</style>
